// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PublicationVersionFileModel } from "./PublicationVersionFileModel";
import {
  PublicationVersionFileModelFromJSON,
  PublicationVersionFileModelFromJSONTyped,
  PublicationVersionFileModelToJSON,
  PublicationVersionFileModelToJSONTyped,
} from "./PublicationVersionFileModel";

/**
 *
 * @export
 * @interface PublicationVersionFile
 */
export interface PublicationVersionFile {
  /**
   *
   */
  name: string;
  /**
   *
   */
  ref: string;
  /**
   *
   */
  file: PublicationVersionFileModel;
}

/**
 * Check if a given object implements the PublicationVersionFile interface.
 */
export function instanceOfPublicationVersionFile(value: object): value is PublicationVersionFile {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("ref" in value) || value["ref"] === undefined) return false;
  if (!("file" in value) || value["file"] === undefined) return false;
  return true;
}

export function PublicationVersionFileFromJSON(json: any): PublicationVersionFile {
  return PublicationVersionFileFromJSONTyped(json, false);
}

export function PublicationVersionFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionFile {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    ref: json["ref"],
    file: PublicationVersionFileModelFromJSON(json["file"]),
  };
}

export function PublicationVersionFileToJSON(json: any): PublicationVersionFile {
  return PublicationVersionFileToJSONTyped(json, false);
}

export function PublicationVersionFileToJSONTyped(
  value?: PublicationVersionFile | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    ref: value["ref"],
    file: PublicationVersionFileModelToJSON(value["file"]),
  };
}
